module.exports = __webpack_public_path__ + "static/media/Corteva_From_Data_to_Decision-mobile.b25beb2f.jpg";